import { TypesForPages } from '../../interface/Destructuring';

export const Paginado = (
  { countries, currentPage, setCurrentPage, setCountriesPerPage, minPageNumber, setMinPageNumber, maxPageNumber, setMaxPageNumber, }: 
  TypesForPages
) => {
  const pagina = (number: number) => {
    setCurrentPage(number);
    number === 1 ? setCountriesPerPage(9) : setCountriesPerPage(10);
    //*   5            5
    if(number >= maxPageNumber) {
      // console.log('NUMBER:', number, 'NUMBER MAX:', maxPageNumber)
      setMinPageNumber(minPageNumber + 4)
      setMaxPageNumber(maxPageNumber + 4)
      //*       4             4                4
    } else if(number <= minPageNumber + 1 && number !== 1) {
      // console.log('NUMBER:', number, 'NUMBER MIX:', minPageNumber)
      setMinPageNumber(minPageNumber - 4)
      setMaxPageNumber(maxPageNumber - 4)
    }
  };

  const pagesNumber: number[] = [];
  const allPages: number = Math.ceil(countries.length / 10)
  //*                 Redondea ^  250                 / 10 = 25 => ceil()
  for (let i = 1; i <= allPages; i++) {
    pagesNumber.push(i);
  }

  return (
    <div className='pagination__container' >
      {currentPage !== 1 && (
        <button 
          onClick={() => pagina(currentPage - 1)} 
          className={'pagination__container__btn'} 
        >
          &lt;
        </button>
      )}

      {
        pagesNumber.slice(minPageNumber, maxPageNumber).map((number: number) => {
          return (
            <button 
              key={number} 
              onClick={() => pagina(number)} 
              className={currentPage !== number ? 'pagination__container__btn' : 'pagination__container__current'}
            >
              {number}
            </button>
          );
        })
      }

      {currentPage !== allPages && (
        <button 
          onClick={() => pagina(currentPage + 1)} 
          className={'pagination__container__btn'}
        >
          &gt;
        </button>
      )}
    </div>
  );
}
